// Shared read-only styling for rendered <ReactMarkdown> output — keeps the markdown preview pane
// visually identical wherever it appears (designer's system prompt editor, knowledge manager docs).
export const MARKDOWN_PREVIEW_SX = {
  "& h1, & h2, & h3": {color: "#23264D", fontWeight: 700, mt: 1.5, mb: 0.75},
  "& h1": {fontSize: 20},
  "& h2": {fontSize: 17},
  "& h3": {fontSize: 14},
  "& p": {m: 0, mb: 1},
  "& ul, & ol": {mt: 0, mb: 1, pl: 2.5},
  "& a": {color: "#8491F7"},
  "& blockquote": {m: 0, mb: 1, pl: 1.5, borderLeft: "2px solid #ECECF3", color: "#6B6B80"},
  "& code": {bgcolor: "#ECECF3", borderRadius: "4px", px: 0.5, py: 0.1, fontSize: 12, fontFamily: "monospace"},
  "& pre": {
    bgcolor: "#ECECF3", borderRadius: "10px", p: 1.5, overflow: "auto",
    "& code": {bgcolor: "transparent", p: 0},
  },
  "& table": {borderCollapse: "collapse", width: "100%", mb: 1},
  "& th, & td": {border: "1px solid #ECECF3", px: 1, py: 0.5, fontSize: 12.5, textAlign: "left"},
  "& hr": {border: "none", borderTop: "1px solid #ECECF3", my: 1.5},
};

export default MARKDOWN_PREVIEW_SX;
